<template>
  <div class="flex items-center gap-2">
    <UAvatar
      :src="LogoImage"
      alt="kasa-icon"
      :ui="{
        root: 'rounded-lg',
        image: 'size-5',
      }"
    >
    </UAvatar>
    <div
      v-if="!props.collapsed"
      class="flex flex-col justify-center gap-0.5"
    >
      <span class="text-xs font-semibold leading-4">
        ตั้งค่าระบบ KOSA
      </span>
      <span
        v-if="!isSuperUser"
        class="text-xs font-normal leading-4 text-muted"
      >
        {{ currentUser?.company?.name }}
      </span>
      <span
        v-else
        class="text-xs font-normal leading-4 text-muted"
      >
        ทั้งหมด
      </span>
      <!-- <div
        v-else
        class="flex gap-1 items-center"
      >
        <span class="text-xs font-normal leading-4 text-muted">
          {{ currentUser?.company?.name }}
        </span>
        <UIcon
          class="size-3"
          :class="[
            'transition-transform duration-200',
            // { 'rotate-180': !open },
          ]"
          name="i-lucide-chevron-up"
        >
        </UIcon>
      </div> -->
    </div>
  </div>
</template>

<script lang="ts" setup>
import LogoImage from "@/assets/images/logo.svg";

interface Props {
  collapsed?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  collapsed: false,
});

const authStore = useAuthStore();
const { isSuperUser, user: currentUser } = storeToRefs(authStore);
</script>

<style></style>
